export const LANGUAGES = [
  { label: "اللغة العربية", code: "ar" },
  { label: "English", code: "en-US" },
];